import PropTypes from 'prop-types';
import { useState } from 'react';
import { Modal } from 'react-bootstrap';
import { useDispatch } from 'react-redux';
import Select from 'react-select';
import { changeShareProject } from 'redux/projectsSlice';
import ModalButtonsContainer from 'sites/common/ModalButtonsContainer';
import ButtonAccept from 'utils/buttons/ButtonAccept';
import ButtonClose from 'utils/buttons/ButtonClose';
import messageHandler from 'utils/messageHandler';

const options = [
  {
    value: 0,
    label: 'No Comparte'
  },
  {
    value: 30,
    label: 'Comparte al 30%'
  },
  {
    value: 50,
    label: 'Comparte al 50%'
  }
];

const ShareModalProject = ({
  selected,
  setSelected,
  setShow,
  setCheckChanges
}) => {
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(false);
  const [shareValue, setShareValue] = useState(0);

  const HandleClose = () => setShow(false);

  const HandleAction = async () => {
    // Filter by status to avoid errors (like trying to share a pending project)
    let selectedFiltered = [];
    selectedFiltered = selected.filter(
      prop => prop.status === 'Activa' || prop.status === 'Pausada'
    );

    const promises = await Promise.allSettled(
      selectedFiltered.map(async prop => {
        const res = await dispatch(
          changeShareProject(prop.id, shareValue, !!shareValue)
        );
        return res;
      })
    );

    // Reset the selected array and force to update prop list
    setSelected([]);
    setCheckChanges(true);

    const success = promises.filter(
      promise => promise.status === 'fulfilled'
    ).length;
    const filtered = selected.length - selectedFiltered.length;

    // Generate a message with the results of the actions
    const message = (
      <div>
        {!promises.length === success && (
          <p>{`Se procesaron ${promises.length} emprendimientos.`}</p>
        )}
        <p>{`${success} emprendimientos fueron compartidos correctamente.`}</p>
        {!promises.length === success && (
          <p>{`El total de procesos fallidos es de ${
            promises.length - success + filtered
          }.`}</p>
        )}
      </div>
    );

    messageHandler('success', message);
    HandleClose();
  };

  return (
    <Modal
      keyboard={true}
      show={true}
      onHide={HandleClose}
      backdrop="static"
      centered
    >
      <Modal.Header closeButton>
        <Modal.Title>Compartir emprendimientos</Modal.Title>
      </Modal.Header>

      <Modal.Body>
        <div className="mb-4" style={{ color: '#4a4949' }}>
          <p>
            Los <strong>{selected.length} emprendimientos </strong>{' '}
            seleccionados cambiarán la manera en la que están siendo
            compartidos.
          </p>

          <Select
            name="branch_office_id"
            placeholder="-- Elija una opción --"
            options={options}
            value={shareValue.value}
            onChange={e => setShareValue(e.value)}
          />
        </div>
        <ModalButtonsContainer>
          <ButtonClose text="Cancelar" funcion={HandleClose} />
          <ButtonAccept
            text={loading ? 'Cargando...' : 'Aceptar'}
            funcion={() => {
              setLoading(true);
              setTimeout(() => {
                HandleAction();
              }, [1000]);
            }}
            disabled={loading}
          />
        </ModalButtonsContainer>
      </Modal.Body>
    </Modal>
  );
};

ShareModalProject.propTypes = {
  selected: PropTypes.array.isRequired,
  setSelected: PropTypes.func.isRequired,
  setShow: PropTypes.func.isRequired,
  setCheckChanges: PropTypes.func.isRequired
};

export default ShareModalProject;
